module.exports = __webpack_public_path__ + "static/img/close_icon.9c943d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/close_icon.png
// module id = 517
// module chunks = 1 2 3 4 5 6